import { Building2, NotebookPen, ShieldCheck, Network } from "lucide-react";

export const PILLARS = [
  { key: "form", name: "Form", line: "Company formation and registration, from structure choice to certificate.", Icon: Building2 },
  { key: "govern", name: "Govern", line: "Corporate secretarial, registers, resolutions and annual filings.", Icon: NotebookPen },
  { key: "comply", name: "Comply", line: "Regulatory and AML/CFT compliance aligned to local requirements.", Icon: ShieldCheck },
  { key: "structure", name: "Structure", line: "Holding and group structures across more than one jurisdiction.", Icon: Network },
];

// "What we do in every jurisdiction" — repeated verbatim on jurisdiction detail pages.
export const AtlasPillars = ({ heading = "What we do in every jurisdiction" }) => (
  <section data-testid="atlas-pillars" className="bg-[#F6F1E4] border-t border-charcoal/10">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 md:py-24">
      <h2 className="font-serif text-3xl md:text-4xl text-charcoal max-w-2xl">{heading}</h2>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-12">
        {PILLARS.map(({ key, name, line, Icon }) => (
          <div key={key} data-testid={`pillar-${key}`}>
            <Icon className="w-7 h-7 text-forest" strokeWidth={1.4} />
            <h3 className="mt-5 font-serif text-xl text-charcoal">{name}</h3>
            <p className="mt-3 font-sans text-sm leading-relaxed text-charcoal/65">{line}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
